import { inject } from '@angular/core';
import { HttpContextToken, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export function errorsInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    let snackBar = inject(MatSnackBar);
    return next(req).pipe(catchError((e: HttpErrorResponse) => {
        snackBar.open(e.error?.error ?? e.error ?? e.message, 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
        });

        console.log(e);
        return EMPTY;
    }));
}
